import { Routes } from '@angular/router';
import { AppBaseComponent } from './app.base.component';
import { AxthGuard } from './guards/axth.guard';
import { CcmhmannoHomeComponent } from './pagecode/chm/ccmhmanno/home/ccmhmanno.home.component';
import { ErrorComponent } from './pagecode/commonpage/error/error.component';
import { PpalLoginComponent } from './pagecode/commonpage/paypal/login/ppal.login.component';
import { PaypalComponent } from './pagecode/commonpage/paypal/paypal.component';
import { CcmotlgacHomeComponent } from './pagecode/cot/ccmotlgac/home/ccmotlgac.home.component';
import { ErrorPopupComponent } from './pagecode/commonpage/error-popup/error-popup.component';

export const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
        path: 'main',
        component: CcmhmannoHomeComponent,
        canActivate: [AxthGuard],
        canActivateChild: [AxthGuard],
        loadChildren: () => import('./pagecode/chm/ccmhmanno/home/ccmhmanno.home.module').then(m => m.CcmhmannoHomeModule)
    },
    {
        path: 'home',
        canActivate: [AxthGuard],
        canActivateChild: [AxthGuard],
        loadChildren: () => import('./pagecode/chm/ccmhmanno/home/ccmhmanno.home.module').then(m => m.CcmhmannoHomeModule)
    },
    {
        // GIB-70 [Defect] 前端程式在不是AOT狀態下編譯無法正常使用
        path: 'cot', component: AppBaseComponent,
        canActivate: [AxthGuard], canActivateChild: [AxthGuard],
        loadChildren: () => import('./pagecode/cot/cot.module').then(m => m.CotModule)
    },
    { path: 'init', redirectTo: '/cot/ccmotlgin/init' },
    { path: 'login', redirectTo: '/cot/ccmotlgin/ccmotlginhome' },
    { path: 'logout', redirectTo: '/cot/ccmotlgin/ccmotlginlogout' },
    {
        // GIB-5077 新增登入認證入口
        path: 'user_authentication', component: CcmotlgacHomeComponent,
        loadChildren: () => import('./pagecode/cot/ccmotlgac/ccmotlgac.module').then(m => m.CcmotlgacModule)
    },
    { path: 'error', component: ErrorComponent },
    { path: 'error-popup', component: ErrorPopupComponent },
    { path: 'paypal', component: PaypalComponent },
    { path: 'ppallogin', component: PpalLoginComponent },
    // otherwise redirect to home
    { path: '**', redirectTo: 'error' }
];
